import { render } from "./EscolhaDePais.vue?vue&type=template&id=408b8819&scoped=true"
import script from "./EscolhaDePais.vue?vue&type=script&lang=js"
export * from "./EscolhaDePais.vue?vue&type=script&lang=js"

import "./EscolhaDePais.vue?vue&type=style&index=0&id=408b8819&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408b8819"]])

export default __exports__